import type { RedoMerchantEmailTemplatesRpcClient } from "@redotech/redo-merchant-email-templates-rpc/client";
import { createRedoMerchantEmailTemplatesRpcClient } from "@redotech/redo-merchant-email-templates-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoMerchantEmailTemplatesRpcClientContext: Context<
  RedoMerchantEmailTemplatesRpcClient | undefined
> = createContext<RedoMerchantEmailTemplatesRpcClient | undefined>(undefined);
RedoMerchantEmailTemplatesRpcClientContext.displayName =
  "RedoMerchantEmailTemplatesRpcClientContext";

export function RedoMerchantEmailTemplatesRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const client = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoMerchantEmailTemplatesRpcClient({
      baseURL: new URL(`${baseUrl}/email-templates-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);
  return (
    <RedoMerchantEmailTemplatesRpcClientContext.Provider value={client}>
      {children}
    </RedoMerchantEmailTemplatesRpcClientContext.Provider>
  );
}
